import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getWidgetType, widgets } from "./utils/general";
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from "react-dnd-touch-backend";
import {
  DndProvider,
  TouchTransition,
  MouseTransition,
  Preview
} from "react-dnd-multi-backend";

function DragElement(item) {
  const getWidgets = widgets;
  const filterWidgetPreview = getWidgets.filter(
    (data) => data.type === item?.text
  );

  return <div>{getWidgetType(filterWidgetPreview[0])}</div>;
}

export default DragElement;


const HTML5toTouch = {
  backends: [
    {
      id: "html5",
      backend: HTML5Backend,
      transition: MouseTransition
    },
    {
      id: "touch",
      backend: TouchBackend,
      options: { enableMouseEvents: true },
      preview: true,
      transition: TouchTransition
    }
  ]
};
const generatePreview = (props) => {
  const { item, style } = props;
  const newStyle = {
    ...style
  };

  return (
    <div style={newStyle}>
      <DragElement {...item} />
    </div>
  );
};

const rootElement = document.getElementById('root');

// Check if we're in pre-rendering mode (react-snap)
const isPreRendered = rootElement.hasChildNodes() && 
  window.navigator.userAgent === 'ReactSnap';

if (isPreRendered) {
  // Use hydrateRoot for pre-rendered content
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <DndProvider options={HTML5toTouch}>
        <Preview>{generatePreview}</Preview>
        <App />
      </DndProvider>
    </React.StrictMode>
  );
} else {
  // Normal render for development and production
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <DndProvider options={HTML5toTouch}>
        <Preview>{generatePreview}</Preview>
        <App />
      </DndProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 